import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from './services/permissions.service';

@Directive({ selector: '[appPermission]' })
export class PermissionDirective {
  readonly appPermission = input.required<string>();
  private readonly permissions = inject(PermissionsService);
  private readonly template = inject(TemplateRef<unknown>);
  private readonly container = inject(ViewContainerRef);
  private visible = false;

  constructor() {
    effect(() => {
      const visible = this.permissions.canNavigate(this.appPermission());
      if (visible === this.visible) return;
      this.visible = visible;
      this.container.clear();
      if (visible) this.container.createEmbeddedView(this.template);
    });
  }
}
